import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  HiHome,
  HiRocketLaunch,
  HiGift,
  HiUser
} from "react-icons/hi2";
import pwsLogo from "../../assets/logo800.webp";
import Haptic from "./Haptic";
import "./Navbar.css";

export default function Navbar() {
  const { t } = useTranslation('navbar');
  const location = useLocation();
  const navigate = useNavigate();

  // Android: real vibration. iOS: no-ops here (no Vibration API) - gets its native
  // haptic tick instead via the Haptic wrapper's switch-input overlay below.
  const vibrate = () => {
    if (navigator.vibrate) navigator.vibrate(30);
  };

  const goTo = (path) => {
    vibrate();
    navigate(path);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="nav">
      <img src={pwsLogo} alt="Playworld" className="nav-logo" />
      <ul className="nav-list">
        <li className="nav-item">
          <Haptic onTap={() => goTo('/')} inline>
            <Link
              to="/"
              className={`nav-link ${isActive('/') ? 'active' : ''}`}
              aria-label={t('home')}
            >
              <HiHome size={26} />
              <span className="nav-label">{t('home')}</span>
            </Link>
          </Haptic>
        </li>
        <li className="nav-item">
          <Haptic onTap={() => goTo('/Products')} inline>
            <Link
              to="/Products"
              className={`nav-link ${isActive('/Products') ? 'active' : ''}`}
              aria-label={t('products')}
            >
              <HiRocketLaunch size={24} />
              <span className="nav-label">{t('products')}</span>
            </Link>
          </Haptic>
        </li>
        <li className="nav-item">
          <Haptic onTap={() => goTo('/coupons')} inline>
            <Link
              to="/coupons"
              className={`nav-link ${isActive('/coupons') ? 'active' : ''}`}
              aria-label={t('coupons')}
            >
              <HiGift size={24} />
              <span className="nav-label">{t('coupons')}</span>
            </Link>
          </Haptic>
        </li>
        <li className="nav-item">
          <Haptic onTap={() => goTo('/login')} inline>
            <Link
              to="/login"
              className={`nav-link ${location.pathname.toLowerCase().startsWith('/login') || location.pathname.toLowerCase().startsWith('/profile') || location.pathname.toLowerCase().startsWith('/settings') ? 'active' : ''}`}
              aria-label={t('profile')}
            >
              <HiUser size={26} />
              <span className="nav-label">{t('profile')}</span>
            </Link>
          </Haptic>
        </li>
      </ul>
    </nav>
  );
}
